<template>
    <layout title="Overzicht">
      <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none" tabindex="0">
        <p>Hier komen dingen op basis van je organisation_id</p>
      </main>
    </layout>
  </template>
  
  <script>
  import Layout from '@/Shared/Layout'
  
  export default {
    props: {
      
    },
  
    components: {
      Layout,
      
  },
  
    data: () => ({
      
    }),
    methods: {
      
    }
  }
  
  </script>
  